import { Badge } from '@nexelem/components';
import { KanbanQueueView, KanbanTaskView } from '@nexelem/graphne-api';
import { CUSTOM_ICONS } from '@nexelem/icons';
import { useCustomTranslation } from '../../../../hooks';
import { NodeLabel } from '../Gantt/components';
import { useFormatTaskDuration, useProductionTaskLocate } from '../Gantt/hooks';
import { TaskMainValueOptions, useProductionPlanSettings } from '../components';

type KanbanTaskSearchResultProps = {
  queue: KanbanQueueView;
  task: KanbanTaskView;
  batchName?: string;
};

export const KanbanTaskSearchResult = ({ queue, task, batchName }: KanbanTaskSearchResultProps) => {
  const { tWrapper: batchTWrapper } = useCustomTranslation('products.productionPlan');
  const { tWrapper: areaTWrapper } = useCustomTranslation('workStation.list');
  const formatTaskDuration = useFormatTaskDuration();
  const showOnTask = useProductionPlanSettings((state) => state.kanban.showOnTask);
  const showProductName = useProductionPlanSettings((state) => state.taskMainValue === TaskMainValueOptions.PRODUCT);
  const locate = useProductionTaskLocate();

  const productionOrderNumber = task.productionOrderDetails?.number;
  const productionOrderExternalNumber = task.productionOrderDetails?.externalId;

  return (
    <div
      className="flex cursor-pointer items-center justify-between gap-2 border-border-secondary px-6 py-2 not-last:border-b hover:bg-surface-focus-lighter"
      onClick={() => locate({ taskId: task.id, queueId: queue.id, markAsSearchSelected: true })}
    >
      <div className="flex flex-col gap-2">
        {batchName && (
          <Badge className="w-fit" StartIcon={<CUSTOM_ICONS.Merge className="text-icon-darker" />}>
            {`${batchTWrapper('batch')} ${batchName}`}
          </Badge>
        )}
        <div className="flex flex-col gap-1">
          <div className="text-s16-sb">{showProductName ? task.productName : task.name}</div>
          <div className="flex gap-2">
            {showOnTask.productionOrderNumber && productionOrderNumber && (
              <NodeLabel className="min-w-0 shrink-4">{productionOrderNumber}</NodeLabel>
            )}
            {showOnTask.productionOrderExternalNumber && productionOrderExternalNumber && (
              <NodeLabel className="min-w-0 shrink-5">{productionOrderExternalNumber}</NodeLabel>
            )}
          </div>
        </div>
        <div className="text-s11-sb text-text-secondary uppercase">
          <span>{formatTaskDuration({ startDate: new Date(task.start), endDate: new Date(task.end) })}</span>
          <div className="flex gap-x-4">
            <span>{queue.shortName}</span>
            <span>{areaTWrapper('area', { areaName: queue.area.name })}</span>
          </div>
        </div>
      </div>
      <div className="text-s16 text-nowrap">
        {task.progress.totalAmount.amount} {task.progress.totalAmount.unit.name}
      </div>
    </div>
  );
};
